// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar {
    width: 100%;
    background-color: #f3f3f3;
    border: 1px solid #7c7c7c;
    border-radius: 8px;
    margin-top: -8px;
}

.progress-bar-fill {
    height: 20px;
    background: linear-gradient(to left, rgba(14, 27, 42, 255), rgba(71, 91, 126, 255));
    width: 0;
    border-radius: 8px;
    transition: width 0.2s;
}

progress {
    width: 100%;
    height: 20px;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 10px;
    background-color: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/ProgressBar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mFAAmF;IACnF,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":[".progress-bar {\n    width: 100%;\n    background-color: #f3f3f3;\n    border: 1px solid #7c7c7c;\n    border-radius: 8px;\n    margin-top: -8px;\n}\n\n.progress-bar-fill {\n    height: 20px;\n    background: linear-gradient(to left, rgba(14, 27, 42, 255), rgba(71, 91, 126, 255));\n    width: 0;\n    border-radius: 8px;\n    transition: width 0.2s;\n}\n\nprogress {\n    width: 100%;\n    height: 20px;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-top: 10px;\n    background-color: #ddd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
